<template>
  <header class="Footer" id="Footer">
    <div class="footer_content">
      <div class="belt"></div>
      <div class="footer_wrapper">
        <div class="footer_text">
          <div class="logo">
            <img src="@/assets/img/logo.png" alt="logo cayros">
          </div>
          <div class="footer_detail">
            <ul>
              <li>
                (+51) 956 411 538
              </li>
              <li>
                promotoria@colegiocayros.edu.pe
              </li>
              <li>
                Av. José Carlos Mariátegui Lt 01 Grocio Prado
              </li>
              <li class="copy">
                ©Cayros School 2020
                <div class="social">
                  <a href="https://www.facebook.com/ColegioCayrosChincha" target="_blank">Facebook</a>
                  <a href="https://api.whatsapp.com/send?phone=51956411538&text=Hola,%20Quiero%20informacion%20sobre%20Cayros%20School" target="_blank">Whatsapp</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer_video">
          <a href="https://goo.gl/maps/ahsmdcemEqraWJQE6" target="_blank" class="video_cover">
            <div class="place">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M20 20.0002C18.1667 20.0002 16.6667 18.5002 16.6667 16.6668C16.6667 14.8335 18.1667 13.3335 20 13.3335C21.8334 13.3335 23.3334 14.8335 23.3334 16.6668C23.3334 18.5002 21.8334 20.0002 20 20.0002ZM30 17.0002C30 10.9502 25.5834 6.66683 20 6.66683C14.4167 6.66683 10 10.9502 10 17.0002C10 20.9002 13.25 26.0668 20 32.2335C26.75 26.0668 30 20.9002 30 17.0002ZM20 3.3335C27 3.3335 33.3334 8.70016 33.3334 17.0002C33.3334 22.5335 28.8834 29.0835 20 36.6668C11.1167 29.0835 6.66669 22.5335 6.66669 17.0002C6.66669 8.70016 13 3.3335 20 3.3335Z" fill="#F8DE32"/>
              </svg>
              <p>CHINCHA, ICA</p>
            </div>
            <img src="@/assets/img/footer_bg.png" alt="presentacion">
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Header',
  mounted () {
    // window.addEventListener('scroll', () => {
    //   const footer = document.getElementById('Footer')
    //   let top = document.documentElement.scrollTop
    //   let height = document.documentElement.clientHeight
    //   if ( top + (height + 100) > footer.offsetTop + (footer.clientHeight / 2) ) {
    //     footer.classList.add('trigger')
    //   }
    // })
  }
}
</script>

<style scoped lang="sass">
@import '../assets/css/app.sass'
.Footer
  position: relative
  .footer_content
    width: 980px
    height: 400px
    margin: 0 auto
    z-index: 2
    &:before, &:after
      content: ''
      position: absolute
      right: 0
      top: 0
      height: 400px
      width: 50vw
      background-color: $secondary_color
      z-index: 0
    &:after
      right: inherit
      left: 0
      background-color: $primary_color
    .footer_wrapper
      display: flex
      align-items: center
      width: 100%
      height: 100%
      position: relative
      background-color: $primary_color
      z-index: 1
      &:before
        content: ''
        position: absolute
        right: 0
        top: 0
        height: 100%
        width: 170px
        background-color: $secondary_color
      .footer_text
        flex: 1
        padding-left: 70px
        z-index: 3
        .logo
          img
            width: 50px
        .footer_detail
          ul
            margin-top: 30px
            li
              color: white
              font-family: $font
              font-size: 14px
              margin-bottom: 17px
              display: flex
              align-items: center
              &.copy
                color: rgba(white, .5)
                .social
                  margin-left: 20px
                  a
                    color: rgba(white, .5)
                    margin-right: 15px
      .footer_video
        padding-right: 70px
        z-index: 2
        .video_cover
          height: 220px
          width: 220px
          background-color: $primary_light_color
          box-shadow: 0 4px 25px 2px rgba(black, .1)
          transition: all ease-in-out .4s
          position: relative
          display: flex
          justify-content: center
          align-items: center
          &:before, &:after
            position: absolute
            content: ''
            top: 0
            left: 0
            width: 12px
            height: 12px
            background-color: $accent_color
            transition: all ease-in-out .5s
          &:after
            left: inherit
            top: inherit
            bottom: 0
            right: 0
          .place
            position: absolute
            display: flex
            justify-content: center
            align-items: center
            flex-direction: column
            z-index: 3
            p
              font-size: 14px
              font-family: $font
              letter-spacing: 1px
              color: white
              margin-top: 10px
            svg
              width: 36px
          img
            display: block
            object-fit: cover
            width: 220px
            height: 220px
            max-height: 220px
            transition: all ease-in-out .5s

@media screen and (max-width: 980px)
  .Footer
    .footer_content
      width: 760px
      .footer_wrapper
        .footer_text
          .footer_detail
            ul
              li
                font-size: 13px

@media screen and (max-width: 760px)
  .Footer
    .footer_content
      width: 480px
      height: 620px
      &:after
        width: 100%
        height: 620px
      &:before
        width: 100%
        height: 160px
        bottom: 0
        top: inherit
        z-index: 1
      .footer_wrapper
        flex-direction: column
        justify-content: space-evenly
        align-items: flex-start
        &:before
          width: 100%
          height: 160px
          bottom: 0
          top: inherit
        .footer_text
          padding-left: 0
          flex: 0
        .footer_video
          padding-right: 0
          align-self: flex-end

@media screen and (max-width: 560px)
  .Footer
    .footer_content
      width: 320px
      .footer_wrapper
        .footer_video
          .video_cover
            width: 100%
            img
              width: 100%

@media screen and (max-width: 400px)
  .Footer
    .footer_content
      width: 100%
      padding:
        left: 40px
        right: 40px
      box-sizing: border-box
      .footer_wrapper
        .footer_text
          .footer_detail
            ul
              li
                line-height: 1.7
                margin-bottom: 10px
                &.copy
                  flex-wrap: wrap
                  .social
                    margin-left: 0
                    margin-right: 20px
                    margin-top: 10px
</style>